export default __webpack_public_path__ + "static/32-92e044fb161d7aa8b515f6f640b996a6.jpg";